// BlogCard 전용 : 블로그 포스트 목록
import blogImg01 from "../assets/blog01.png";
import blogImg02 from "../assets/blog02.png";
import blogImg03 from "../assets/blog03.png";

export const BLOG_DATA = [
  {
    id: 1,
    title: "[React] TMDB API: 한 번의 요청으로 영화 상세정보와 유튜브 예고편",
    date: "2026.01.18",
    url: "https://yong-mi.tistory.com/23",
    bg: blogImg01,
  },
  {
    id: 2,
    title:
      "인테리어 가구 판매 및 커뮤니티 플랫폼 (React, Spring Boot) 프로젝트 회고록",
    date: "2024.09.22",
    url: "https://blog.naver.com/jeonnni/223591771096",
    bg: blogImg02,
  },
  {
    id: 3,
    title: "[Java] switch case 문과 if else 문을 이용한 가위 바위 보 게임",
    date: "2024.03.31",
    url: "https://blog.naver.com/jeonnni/223401294869",
    bg: blogImg03,
  },
];
